import { useLocation, useSelector } from 'umi';
import { useMemo } from 'react';
import useIntls from './useIntls';

type TMenuItem = {
  title: string;
  titleCn: string;
  href?: string;
  children?: TMenuItem[];
};

/**
 * 根据当前路由获取菜单标题
 * @returns { title: 英文标题, titleCn: 中文标题, currentTitle: 当前语言对应的标题 }
 */
export default function useMenuTitle() {
  const location = useLocation();
  const { isEn, intl } = useIntls();
  const { listMenu } = useSelector(
    (state: any) => state.opinionMarketingMenu || {},
  );

  const menuTitle = useMemo(() => {
    if (!listMenu || !location?.pathname) {
      return { title: '', titleCn: '', currentTitle: '' };
    }

    const currentPath = location.pathname;
    // 遍历菜单查找匹配当前路由的菜单项
    for (const group of listMenu) {
      if (group.children) {
        for (const item of group.children) {
          if (item.children) {
            for (const child of item.children) {
              if (child.href && currentPath.includes(child.href)) {
                return {
                  title: child.title,
                  titleCn: child.titleCn,
                  currentTitle: isEn ? child.title : child.titleCn,
                };
              }
            }
          }
          if (item.href && currentPath.includes(item.href)) {
            return {
              title: item.title,
              titleCn: item.titleCn,
              currentTitle: isEn ? item.title : item.titleCn,
            };
          }
        }
      }
    }

    return { title: '', titleCn: '', currentTitle: '' };
  }, [listMenu, location?.pathname, intl]);

  return menuTitle;
}
